import * as actionTypes from '../actionTypes'
// import api from '../api'
import { autoLogin } from './login'
//import { loadInitialDropdowns } from './homePage'

export const startup = () => {
	return async (dispatch, getState) => {
		dispatch({type: actionTypes.STARTUP_STARTED})
		await dispatch(autoLogin()) 
		dispatch({type: actionTypes.STARTUP_COMPLETED})
	}
}



// WEBPACK FOOTER //
// ./src/actions/startup.js